import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Checkbox from "components/core/Checkbox";

import "./FilterSection.scss";

const FilterSection = ({
	title,
	options,
	selectedOptions,
	onToggleOption,
	footer,
	className
}) => {
	// Handle both array and object formats
	const optionsList = Array.isArray(options) ? options : Object.values(options);

	return (
		<div className={classnames("filter-section", className)}>
			{title && <span className="filter-section-title">{title}</span>}
			<div className="filter-section-options">
				{optionsList.map((option) => {
					const optionValue = typeof option === "object" ? option.value : option;
					const optionLabel = typeof option === "object" ? option.label : option;
					const isSelected = selectedOptions.includes(optionValue);

					return (
						<Checkbox
							key={optionValue}
							id={`filter-${optionValue}`}
							checked={isSelected}
							onChange={() => onToggleOption(optionValue)}
							label={optionLabel}
						/>
					);
				})}
			</div>
			{footer && <div className="filter-section-footer">{footer}</div>}
		</div>
	);
};

FilterSection.propTypes = {
	title: PropTypes.string,
	options: PropTypes.oneOfType([
		// Array format
		PropTypes.arrayOf(
			PropTypes.oneOfType([
				PropTypes.string,
				PropTypes.shape({
					value: PropTypes.string.isRequired,
					label: PropTypes.string.isRequired
				})
			])
		),
		// Object format from Redux
		PropTypes.objectOf(
			PropTypes.shape({
				value: PropTypes.string.isRequired,
				label: PropTypes.string.isRequired
			})
		)
	]).isRequired,
	selectedOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
	onToggleOption: PropTypes.func.isRequired,
	footer: PropTypes.node,
	className: PropTypes.string
};

FilterSection.defaultProps = {
	title: "",
	footer: null,
	className: ""
};

export default FilterSection;
